import React, { useState, useEffect } from "react";
import { format } from "date-fns";

import { Button, Form, Table } from "reactstrap";
import WishResponse from "../WishResponse";
import ZaResponse from "./ZaResponse";
import ZaEditResponse from "./ZaEditResponse";
export default function ZaView() {
  const [display, setDisplay] = useState(false);
  const [displayEditResponses, setDisplayEditResponses] = useState(false);
  const [itemsList, setItemsList] = useState([]);
  const [clickedItemDescription, setClickedItemDescription] = useState("TEST");
  const [clickedItemData, setClickedItemData] = useState();
  const [triger, setTriger] = useState(false);
  const getAllWishItems = async () => {
    try {
      const response = await fetch(`api/v1/WatchHunter/wishItems/`, {
        method: "GET",
        headers: new Headers({ "Content-Type": "application/json" }),
      });
      if (response.ok) {
        console.log(response);
        const payload = await response.json();
        setItemsList(payload);
      }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (err) {
      console.error(err);
      // Handle errors here
    } finally {
      console.log("FINALLY");
    }
  };
  useEffect(() => {
    getAllWishItems();
  }, [triger]);

  const [newOfferResetFormTriger, setNewOfferResetFormTriger] = useState(false)
  const handleResponseBtn = (description, item) => {
    setDisplayEditResponses(false);
    setClickedItemDescription(description);
    setDisplay(true);
    setClickedItemData(item);
    setNewOfferResetFormTriger(true)
  };

  const handleEditResponseBtn = (itemData) => {
    console.log(itemData)
    setDisplay(false)
    setClickedItemData(itemData);
    setDisplayEditResponses(true);
  };
  return (
    <div className="d-flex justify-content-between m-5 align-items-lg-start">
      <div className="zaView">
        <Table bordered hover className="">
          <thead>
            <tr>
              <th>Description</th>
              <th>Agent Name</th>
              <th>Wish ID</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {itemsList &&
              itemsList.map((item, index) => {
                //console.log(item);
                return (
                  <tr key={index}>
                    <td>{item.description}</td>
                    <td>{item.agent.name}</td>
                    <td>{item.wishesId}</td>
                    <td>
                      {item.timestamp
                        ? format(new Date(item.timestamp), "dd/MM/yyyy")
                        : ""}
                    </td>
                    <td className="d-flex flex-column">
                      <Button
                        outline
                        color="dark"
                        onClick={() => {
                          handleResponseBtn(item.description, item);
                          document.getElementById("responseForm").reset();
                        }}
                      >
                        New Offer
                      </Button>
                      {item.offers.length > 0 ? (
                        <Button
                          className="mt-1"
                          outline
                          color="secondary"
                          onClick={() => {
                            handleEditResponseBtn(item);
                            //document.getElementById("responseForm").reset();
                          }}
                        >
                          Edit <b>{item.offers.length}</b> offers
                        </Button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
      <ZaResponse
        newOfferResetFormTriger={newOfferResetFormTriger}
        description={clickedItemDescription}
        display={display}
        setDisplay={setDisplay}
        itemData={clickedItemData}
        setTriger={setTriger}
      />
      {displayEditResponses && (
        <div className="d-flex flex-column mr-auto wishResponses container">
          {" "}
          <div className="d-flex justify-content-between align-items-baseline mt-2">
            <h2>
              Manage all the offers to the wish
            </h2>
            <Button
              outline
              color="dark"
              onClick={() => {
                setDisplayEditResponses(false)
              }}
            >
              X
            </Button>
          </div>
          {clickedItemData.offers.map((offer, index) => {
            return (
              <ZaEditResponse
                key={offer.gid}
                keyforOffer={index}
                itemData={offer}
                wishesID={clickedItemData.wishesId}
                wishesGID={clickedItemData.gid}
                setTriger={setTriger}
                setDisplayEditResponses={setDisplayEditResponses}
                setClickedItemData={setClickedItemData}
                clickedItemData={clickedItemData}
                handleEditResponseBtn={handleEditResponseBtn}
                setItemsList={setItemsList}
                itemsList={itemsList}
              />
            );
          })}{" "}
        </div>
      )}
    </div>
  );
}
